/* DRIVE IQ — ADVENTURE MODE V601.11 PLACE IQ TAP HANDOFF + TOUCH TARGET



   File: adventure-pins.js







   Purpose:



   \- Commit scan pins once per immutable result set.



   \- Keep pin rendering independent from Photo IQ and shelf hydration.



   \- Restore pins only after a real Mapbox style reload, page resume, or



     explicit recovery request.



   \- Preserve exact pin-to-place identity and selected-pin styling.



   \- Prevent duplicate Mapbox layer listeners after style reloads.



   \- Bridge pin taps into the same Place IQ opening path used by result cards.



   \- Keep a permanent, safe-area-aware results restore button available.



   \- Let menu-card selections highlight the exact matching map pin without



     firing another selection/open event.



   \- Change the selected pin to a high-contrast gold focus state.



   \- Add a separate cyan halo layer beneath the selected pin.



   \- Animate a subtle breathing pulse without rebuilding pin data.



   \- Preserve selected pin identity across scan commits and source rewrites.



   \- Reapply selected paint after every Mapbox recovery and result repaint.



   \- Never clear the gold pin unless clearSelection() or clear() is explicit.



   \- Resolve transformed Place IQ and Destination IQ objects back to the exact



     committed scan pin before applying selected styling.



   \- Match by canonical provider ID first, then precise coordinates and name.



   \- Use selected stroke-color expressions instead of forcing white strokes.



   \- Reassert gold after state selection and Place IQ open repaint cycles.



*/







(function(window){



"use strict";



/*

  V601.10 premium visual hierarchy:

  - Featured / Top Pick = gold star marker.

  - Selected place = larger gold star + breathing gold halo.

  - Strong recommendations = smaller warm-gold dots.

  - Regular results = smaller cyan/teal dots.

  - Marker identity, immutable scan commits, recovery, and selection authority remain unchanged.

*/









if(window.DriveIQAdventurePins){return;}







var config=window.DriveIQAdventureConfig;



var state=window.DriveIQAdventureState;



var events=window.DriveIQAdventureEvents;



var mapApi=window.DriveIQAdventureMap;







if(!config||!state||!events||!mapApi){



  throw new Error("Pins requires config/state/events/map.");



}







var SOURCE_ID="diq-adventure-results";



var LAYER_ID="diq-adventure-pins";



var GLOW_LAYER_ID="diq-adventure-pins-glow";



var LABEL_LAYER_ID="diq-adventure-pin-labels";
var HIT_LAYER_ID="diq-adventure-pins-tap-target";
var lastPinTapKey="";
var lastPinTapAt=0;







var selectedKey="";



var selectedItem=null;



var committedItems=[];



var committedSignature="";



var committedAt=0;







var recoveryTimer=null;



var recoveryAttempts=0;



var MAX_RECOVERY_ATTEMPTS=40;



var RECOVERY_DELAY_MS=100;







var boundMap=null;



var listenersBound=false;



var clickHandler=null;



var mouseEnterHandler=null;



var mouseLeaveHandler=null;







var lastWrittenSource=null;



var lastWrittenSignature="";







var RESULTS_TOGGLE_ID="diq-adventure-results-toggle";



var RESULTS_STYLE_ID="diq-adventure-results-access-style";



var resultsToggle=null;



var lastSelectedItem=null;







var pulseTimer=null;



var pulseFrame=0;



var PULSE_INTERVAL_MS=110;



var PULSE_STEPS=32;







function map(){



  return mapApi.getMap();



}







function now(){



  return Date.now?Date.now():(new Date()).getTime();



}







function numberValue(value){



  var parsed=Number(value);



  return isFinite(parsed)?parsed:null;



}







function latitudeFor(item){



  if(!item){return null;}







  if(item.lat!=null){



    return numberValue(item.lat);



  }







  return numberValue(item.latitude);



}







function longitudeFor(item){



  if(!item){return null;}







  if(item.lng!=null){



    return numberValue(item.lng);



  }







  return numberValue(item.longitude);



}







function keyFor(item){



  var latitude=latitudeFor(item);



  var longitude=longitudeFor(item);







  return String(



    item&&(



      item.placeId||



      item.place_id||



      item.googlePlaceId||



      item.google_place_id||



      item.providerPlaceId||



      item.provider_place_id||



      item.mapboxId||



      item.mapbox_id||



      item.id||



      item.label||



      item.name||



      ""



    )



  )+"|"+



  String(latitude==null?"":latitude)+"|"+



  String(longitude==null?"":longitude);



}















function canonicalId(item){



  return String(



    item&&(



      item.placeId||



      item.place_id||



      item.googlePlaceId||



      item.google_place_id||



      item.providerPlaceId||



      item.provider_place_id||



      item.mapboxId||



      item.mapbox_id||



      item.id||



      ""



    )||



    ""



  ).trim();



}







function normalizedName(item){



  return String(



    item&&(



      item.name||



      item.label||



      ""



    )||



    ""



  )



    .toLowerCase()



    .replace(/[^a-z0-9]+/g," ")



    .replace(/\s+/g," ")



    .trim();



}







function coordinateDistance(a,b){



  var aLat=latitudeFor(a);



  var aLng=longitudeFor(a);



  var bLat=latitudeFor(b);



  var bLng=longitudeFor(b);



  var dLat;



  var dLng;







  if(



    aLat==null||



    aLng==null||



    bLat==null||



    bLng==null



  ){



    return Infinity;



  }







  dLat=aLat-bLat;



  dLng=aLng-bLng;







  return Math.sqrt(



    (dLat*dLat)+(dLng*dLng)



  );



}







function resolveCommittedItem(item){



  var candidates=validItems(



    state.get("results.items",committedItems)||



    committedItems



  );



  var requestedKey=keyFor(item);



  var requestedId=canonicalId(item);



  var requestedName=normalizedName(item);



  var best=null;



  var bestDistance=Infinity;



  var index;



  var candidate;



  var candidateId;



  var distance;







  if(!item){



    return null;



  }







  /*



    1. Exact immutable key match.



  */



  for(index=0;index<candidates.length;index+=1){



    candidate=candidates[index];







    if(keyFor(candidate)===requestedKey){



      return candidate;



    }



  }







  /*



    2. Canonical provider identity match.



  */



  if(requestedId){



    for(index=0;index<candidates.length;index+=1){



      candidate=candidates[index];



      candidateId=canonicalId(candidate);







      if(candidateId&&candidateId===requestedId){



        return candidate;



      }



    }



  }







  /*



    3. Coordinate authority. Place IQ and Destination IQ may normalize or



       rename the selected object while preserving the exact coordinates.



       Roughly 0.00012 degrees is about 40 feet in typical US markets.



  */



  for(index=0;index<candidates.length;index+=1){



    candidate=candidates[index];



    distance=coordinateDistance(item,candidate);







    if(distance<bestDistance){



      bestDistance=distance;



      best=candidate;



    }



  }







  if(best&&bestDistance<=0.00012){



    return best;



  }







  /*



    4. Name + near-coordinate fallback for provider records whose coordinate



       precision changed slightly during canonical destination normalization.



  */



  if(requestedName){



    best=null;



    bestDistance=Infinity;







    for(index=0;index<candidates.length;index+=1){



      candidate=candidates[index];







      if(normalizedName(candidate)!==requestedName){



        continue;



      }







      distance=coordinateDistance(item,candidate);







      if(distance<bestDistance){



        bestDistance=distance;



        best=candidate;



      }



    }







    if(best&&bestDistance<=0.001){



      return best;



    }



  }







  return null;



}







function setSelectedItem(item){



  var resolved=resolveCommittedItem(item)||item;







  if(!resolved){



    return false;



  }







  selectedItem=resolved;



  lastSelectedItem=resolved;



  selectedKey=keyFor(resolved);







  return !!selectedKey;



}







function itemForSelectedKey(){



  var item;







  if(selectedItem&&keyFor(selectedItem)===selectedKey){



    return selectedItem;



  }







  item=findCommittedItemByKey(selectedKey)||



    resolveCommittedItem(selectedItem);







  if(item){



    selectedItem=item;



    selectedKey=keyFor(item);



    return item;



  }







  return null;



}







function preserveSelectedIdentity(items){



  var previousKey=selectedKey;



  var previousItem=selectedItem;



  var normalized=validItems(items);



  var resolved;



  var index;







  if(!previousKey){



    return false;



  }







  for(index=0;index<normalized.length;index+=1){



    if(keyFor(normalized[index])===previousKey){



      selectedItem=normalized[index];



      selectedKey=previousKey;



      return true;



    }



  }







  resolved=resolveCommittedItem(previousItem);







  if(resolved){



    selectedItem=resolved;



    selectedKey=keyFor(resolved);



    return true;



  }







  /*



    Do not silently clear selection just because a transient result repaint



    omitted the item. Keep the last immutable identity until an explicit



    clearSelection() or clear().



  */



  selectedItem=previousItem;



  selectedKey=previousKey;



  return !!previousKey;



}







function normalizeResultItems(value){



  if(Array.isArray(value)){



    return value;



  }







  if(value&&Array.isArray(value.items)){



    return value.items;



  }







  if(value&&Array.isArray(value.results)){



    return value.results;



  }







  if(value&&value.payload){



    return normalizeResultItems(value.payload);



  }







  return [];



}







function validItems(items){



  return normalizeResultItems(items).filter(function(item){



    return (



      item&&



      latitudeFor(item)!=null&&



      longitudeFor(item)!=null



    );



  });



}







function resultSignature(items){



  return validItems(items)



    .map(keyFor)



    .join("||");



}







function pinText(item){



  return String([



    item&&item.userFacingCategory,



    item&&item.categoryLabel,



    item&&item.category,



    item&&item.primaryCategory,



    item&&item.poiClass,



    item&&item.entityType,



    item&&item.name,



    item&&item.label,



    item&&item.description,



    item&&item.reason,



    item&&item.recommendedBecause,



    item&&item.tags&&item.tags.join?item.tags.join(" "):""



  ].join(" ")).toLowerCase();



}







function categoryFor(item){



  var text=pinText(item);







  if(item&&item.isLocal===true||/local favorite|local fave|locally owned|family owned|family-owned/.test(text)){return "local";}



  if(/hidden gem|unique local|off the beaten|underrated/.test(text)){return "hidden";}



  if(/coffee|cafe|café|espresso|roaster|bakery/.test(text)){return "coffee";}



  if(/restaurant|food|dining|bbq|burger|pizza|taco|seafood|dessert|ice cream/.test(text)){return "food";}



  if(/park|trail|outdoor|scenic|nature|hiking|campground/.test(text)){return "outdoors";}



  if(/waterfront|beach|bay|gulf|ocean|lake|river|marina|harbor|pier|boardwalk/.test(text)){return "waterfront";}



  if(/shop|shopping|store|retail|market|boutique|mall/.test(text)){return "shopping";}



  if(/music|concert|live music|venue/.test(text)){return "live_music";}



  if(/nightlife|bar|pub|lounge|club/.test(text)){return "nightlife";}



  if(/attraction|museum|landmark|historic|zoo|aquarium|theater|theatre/.test(text)){return "attraction";}



  return "place";



}







function colorForCategory(category){



  switch(String(category||"place")){



    case "local":return "#FFD75E";



    case "food":return "#FF9A3D";



    case "coffee":return "#FFC857";



    case "outdoors":return "#35D07F";



    case "hidden":return "#28E0D0";



    case "waterfront":return "#38BDF8";



    case "shopping":return "#A78BFA";



    case "live_music":return "#F472B6";



    case "nightlife":return "#C084FC";



    case "attraction":return "#FF6B7A";



    default:return "#00D8FF";



  }



}







function glyphForCategory(category){



  switch(String(category||"place")){



    case "local":return "★";



    case "food":return "F";



    case "coffee":return "C";



    case "outdoors":return "O";



    case "hidden":return "◆";



    case "waterfront":return "W";



    case "shopping":return "S";



    case "live_music":return "♪";



    case "nightlife":return "N";



    case "attraction":return "A";



    default:return "•";



  }



}







function tierForIndex(index){

  if(index===0){return "featured";}

  if(index<6){return "strong";}

  return "support";

}







function feature(item,index){

  var category=categoryFor(item);

  var tier=tierForIndex(Number(index)||0);



  return {

    type:"Feature",

    geometry:{

      type:"Point",

      coordinates:[

        longitudeFor(item),

        latitudeFor(item)

      ]

    },

    properties:{

      key:keyFor(item),

      name:String(item.label||item.name||""),

      placeId:String(

        item.placeId||

        item.place_id||

        item.googlePlaceId||

        item.google_place_id||

        ""

      ),

      category:category,

      pinColor:colorForCategory(category),

      glyph:tier==="featured"?"★":"",

      tier:tier,

      featured:tier==="featured"?1:0,

      markerRole:

        tier==="featured"?"top_pick":

        tier==="strong"?"recommended":

        "result"

    }

  };

}







function featureCollection(items){



  return {



    type:"FeatureCollection",



    features:validItems(items).map(function(item,index){



      return feature(item,index);



    })



  };



}











function selectedGlowRadiusExpression(radius){

  return [

    "case",

    ["==",["get","key"],selectedKey],Number(radius||23),

    ["==",["get","tier"],"featured"],15.5,

    0

  ];

}







function selectedGlowOpacityExpression(opacity){

  return [

    "case",

    ["==",["get","key"],selectedKey],Number(opacity||0.30),

    ["==",["get","tier"],"featured"],0.12,

    0

  ];

}







function stopPulse(){



  if(pulseTimer){



    window.clearInterval(pulseTimer);



    pulseTimer=null;



  }







  pulseFrame=0;



}







function applyGlowFrame(){



  var m=map();



  var phase;



  var radius;



  var opacity;







  if(



    !selectedKey||



    !m||



    !m.getLayer||



    !m.getLayer(GLOW_LAYER_ID)



  ){



    return false;



  }







  phase=(Math.sin(



    (pulseFrame/PULSE_STEPS)*Math.PI*2



  )+1)/2;







  radius=20+(phase*5);



  opacity=0.20+(phase*0.16);







  try{



    m.setPaintProperty(



      GLOW_LAYER_ID,



      "circle-radius",



      selectedGlowRadiusExpression(radius)



    );







    m.setPaintProperty(



      GLOW_LAYER_ID,



      "circle-opacity",



      selectedGlowOpacityExpression(opacity)



    );







    return true;



  }catch(error){



    return false;



  }



}







function startPulse(){



  stopPulse();







  if(!selectedKey){



    return false;



  }







  applyGlowFrame();







  pulseTimer=window.setInterval(function(){



    pulseFrame=(pulseFrame+1)%PULSE_STEPS;



    applyGlowFrame();



  },PULSE_INTERVAL_MS);







  return true;



}







function selectedRadiusExpression(){

  return [

    "case",

    ["==",["get","key"],selectedKey],15.5,

    ["==",["get","tier"],"featured"],11.5,

    ["==",["get","tier"],"strong"],7.4,

    5.6

  ];

}







function selectedColorExpression(){

  return [

    "case",

    ["==",["get","key"],selectedKey],"#FFD966",

    ["==",["get","tier"],"featured"],"#FFD966",

    ["==",["get","tier"],"strong"],"#E9B94D",

    "#43E7F5"

  ];

}







function selectedOpacityExpression(){

  return [

    "case",

    ["==",["get","key"],selectedKey],1,

    ["==",["get","tier"],"featured"],1,

    ["==",["get","tier"],"strong"],0.95,

    0.88

  ];

}







function selectedStrokeColorExpression(){

  return [

    "case",

    ["==",["get","key"],selectedKey],"#FFF4BE",

    ["==",["get","tier"],"featured"],"#FFF0A4",

    ["==",["get","tier"],"strong"],"#FFF0B0",

    "#0A3542"

  ];

}







function selectedStrokeExpression(){

  return [

    "case",

    ["==",["get","key"],selectedKey],4.2,

    ["==",["get","tier"],"featured"],3.2,

    ["==",["get","tier"],"strong"],2.0,

    1.7

  ];

}







function labelSizeExpression(){

  return [

    "case",

    ["==",["get","key"],selectedKey],12.5,

    ["==",["get","tier"],"featured"],10.5,

    0

  ];

}







function labelColorExpression(){

  return "#07121A";

}







function unbindLayerListeners(){



  var m=boundMap;







  if(!m){



    listenersBound=false;



    return;



  }







  try{



    if(clickHandler){



      m.off("click",LAYER_ID,clickHandler);
      m.off("click",HIT_LAYER_ID,clickHandler);



    }



  }catch(error){}







  try{



    if(mouseEnterHandler){



      m.off("mouseenter",LAYER_ID,mouseEnterHandler);



    }



  }catch(error){}







  try{



    if(mouseLeaveHandler){



      m.off("mouseleave",LAYER_ID,mouseLeaveHandler);



    }



  }catch(error){}







  listenersBound=false;



}







function findCommittedItemByKey(key){



  var liveItems=validItems(



    state.get("results.items",committedItems)||committedItems



  );



  var index;







  for(index=0;index<liveItems.length;index+=1){



    if(keyFor(liveItems[index])===key){



      return liveItems[index];



    }



  }







  for(index=0;index<committedItems.length;index+=1){



    if(keyFor(committedItems[index])===key){



      return committedItems[index];



    }



  }







  return null;



}











function safeEmit(name,payload){



  try{



    events.emit(name,payload);



    return true;



  }catch(error){



    return false;



  }



}







function callFirst(target,names,args){



  var index;



  var method;







  if(!target){return false;}







  for(index=0;index<names.length;index+=1){



    method=target[names[index]];







    if(typeof method==="function"){



      try{



        method.apply(target,args||[]);



        return true;



      }catch(error){}



    }



  }







  return false;



}







function uiApi(){



  return (



    window.DriveIQAdventureUI||



    window.DriveIQAdventureResults||



    window.DriveIQAdventureShelf||



    window.DriveIQAdventurePlaceIQ||



    null



  );



}











function nextPaint(callback){



  if(typeof window.requestAnimationFrame==="function"){



    window.requestAnimationFrame(callback);



    return;



  }







  window.setTimeout(callback,0);



}







function openPlaceAuthority(item,source){
  var origin=source||"pin";
  var resolved=resolveCommittedItem(item)||item;
  var placeCard=window.DriveIQAdventurePlaceCard;
  var opened=false;
  var detail={item:resolved,place:resolved,result:resolved,source:origin,key:keyFor(resolved)};

  if(!resolved){return false;}
  lastSelectedItem=resolved;

  /* Place IQ V600.43 exposes open(item, source). Prefer the exact
     controller rather than generic UI aliases that may not exist. */
  if(placeCard&&typeof placeCard.open==="function"){
    try{opened=placeCard.open(resolved,origin)!==false;}
    catch(error){
      try{console.warn("[Adventure Pins] Place IQ open failed",error);}catch(ignore){}
    }
  }

  /* Compatibility fallback only when the actual card did not accept
     the selection. One event is enough: Place IQ listens for pin:selected. */
  if(!opened){safeEmit("pin:selected",detail);}

  nextPaint(function(){reassertSelection("place-open");});
  window.setTimeout(function(){reassertSelection("place-open-settled");},120);
  return opened;
}

function injectResultsAccessStyles(){



  var documentRef=window.document;



  var style;







  if(!documentRef||documentRef.getElementById(RESULTS_STYLE_ID)){



    return;



  }







  style=documentRef.createElement("style");



  style.id=RESULTS_STYLE_ID;



  style.type="text/css";



  style.textContent=[



    "#"+RESULTS_TOGGLE_ID+"{",



      "position:fixed;",



      "left:50%;",



      "bottom:calc(104px + env(safe-area-inset-bottom, 0px));",



      "transform:translateX(-50%);",



      "z-index:2147483000;",



      "display:none;",



      "align-items:center;",



      "justify-content:center;",



      "min-width:146px;",



      "height:46px;",



      "padding:0 16px;",



      "border:1px solid rgba(80,231,255,.40);",



      "border-radius:18px;",



      "background:linear-gradient(180deg,rgba(5,22,35,.97),rgba(2,12,21,.98));",



      "box-shadow:0 16px 38px rgba(0,0,0,.44),0 0 18px rgba(54,219,255,.08);",



      "backdrop-filter:blur(16px);",



      "-webkit-backdrop-filter:blur(16px);",



      "color:#fff;",



      "font:700 14px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;",



      "letter-spacing:.01em;",



      "touch-action:manipulation;",



      "-webkit-tap-highlight-color:transparent;",



    "}",



    "#"+RESULTS_TOGGLE_ID+"[data-visible='true']{display:flex;}",



    "#"+RESULTS_TOGGLE_ID+":active{transform:translateX(-50%) scale(.97);}",



    /*



      Existing result-count pills in recent Adventure builds. Move any match



      above the scan CTA so it cannot cover the button.



    */



    ".diq-results-count,.diq-spots-count,[data-diq-results-count],",



    "[data-adventure-results-toggle],.adventure-results-toggle{",



      "bottom:calc(104px + env(safe-area-inset-bottom, 0px))!important;",



      "z-index:2147482999!important;",



    "}",



    "@media (max-height:700px){",



      "#"+RESULTS_TOGGLE_ID+"{",



        "bottom:calc(88px + env(safe-area-inset-bottom, 0px));",



      "}",



      ".diq-results-count,.diq-spots-count,[data-diq-results-count],",



      "[data-adventure-results-toggle],.adventure-results-toggle{",



        "bottom:calc(88px + env(safe-area-inset-bottom, 0px))!important;",



      "}",



    "}"



  ].join("");







  (documentRef.head||documentRef.documentElement).appendChild(style);



}







function resultsLabel(){



  var count=committedItems.length;







  if(count===1){



    return "1 Place Nearby";



  }







  return String(count)+" Places Nearby";



}







function showResultsAuthority(){



  var ui=uiApi();



  var detail={



    items:committedItems.slice(),



    count:committedItems.length,



    source:"results-toggle"



  };







  callFirst(



    ui,



    [



      "showResults",



      "openResults",



      "showShelf",



      "openShelf",



      "restoreShelf",



      "expandResults",



      "showResultsShelf"



    ],



    [committedItems.slice()]



  );







  safeEmit("results:show",detail);



  safeEmit("results:open",detail);



  safeEmit("shelf:show",detail);



  safeEmit("shelf:open",detail);



  safeEmit("ui:show-results",detail);







  try{



    window.dispatchEvent(



      new CustomEvent("driveiq:adventure-results-open",{



        detail:detail



      })



    );



  }catch(error){}







  return true;



}







function ensureResultsToggle(){



  var documentRef=window.document;







  injectResultsAccessStyles();







  if(!documentRef){



    return null;



  }







  resultsToggle=documentRef.getElementById(RESULTS_TOGGLE_ID);







  if(!resultsToggle){



    resultsToggle=documentRef.createElement("button");



    resultsToggle.id=RESULTS_TOGGLE_ID;



    resultsToggle.type="button";



    resultsToggle.setAttribute("aria-label","Show adventure results");



    resultsToggle.addEventListener("click",function(event){



      if(event){



        event.preventDefault();



        event.stopPropagation();



      }







      showResultsAuthority();



    });







    (documentRef.body||documentRef.documentElement)



      .appendChild(resultsToggle);



  }







  resultsToggle.textContent=resultsLabel();



  resultsToggle.setAttribute(



    "data-visible",



    committedItems.length?"true":"false"



  );







  return resultsToggle;



}







function refreshResultsToggle(){



  var toggle=ensureResultsToggle();







  if(!toggle){return false;}







  toggle.textContent=resultsLabel();



  toggle.setAttribute(



    "data-visible",



    committedItems.length?"true":"false"



  );







  return true;



}











function bindLayerListeners(m){



  if(!m){return false;}







  if(boundMap!==m){



    unbindLayerListeners();



    boundMap=m;



  }







  if(listenersBound){return true;}







  clickHandler=function(event){



    var featureItem=



      event&&event.features&&event.features[0];



    var key=



      featureItem&&



      featureItem.properties&&



      featureItem.properties.key;



    var item;







    if(event&&event.originalEvent){



      try{event.originalEvent.preventDefault();}catch(error){}



      try{event.originalEvent.stopPropagation();}catch(error){}



    }







    if(!key){return;}







    item=findCommittedItemByKey(String(key));







    if(item){
      var tapTime=now();
      if(lastPinTapKey===String(key)&&tapTime-lastPinTapAt<450){return;}
      lastPinTapKey=String(key);
      lastPinTapAt=tapTime;
      select(item,"pin");
      openPlaceAuthority(item,"pin");
    }



  };







  mouseEnterHandler=function(){



    try{



      m.getCanvas().style.cursor="pointer";



    }catch(error){}



  };







  mouseLeaveHandler=function(){



    try{



      m.getCanvas().style.cursor="";



    }catch(error){}



  };







  try{



    m.on("click",LAYER_ID,clickHandler);
    m.on("click",HIT_LAYER_ID,clickHandler);



    m.on("mouseenter",LAYER_ID,mouseEnterHandler);



    m.on("mouseleave",LAYER_ID,mouseLeaveHandler);



    listenersBound=true;



    return true;



  }catch(error){



    unbindLayerListeners();



    return false;



  }



}







function ensureLayer(){



  var m=map();



  var sourceCreated=false;



  var layerCreated=false;







  if(!m||!m.isStyleLoaded||!m.isStyleLoaded()){



    return {



      ready:false,



      map:m,



      sourceCreated:false,



      layerCreated:false



    };



  }







  try{



    if(!m.getSource(SOURCE_ID)){



      m.addSource(SOURCE_ID,{



        type:"geojson",



        data:featureCollection([])



      });



      sourceCreated=true;



    }







    if(!m.getLayer(GLOW_LAYER_ID)){



      m.addLayer({



        id:GLOW_LAYER_ID,



        type:"circle",



        source:SOURCE_ID,



        paint:{



          "circle-radius":selectedGlowRadiusExpression(23),



          "circle-color":"#FFD966",



          "circle-opacity":selectedGlowOpacityExpression(0.30),



          "circle-blur":0.82,



          "circle-stroke-width":0



        }



      });



    }







    if(!m.getLayer(LAYER_ID)){



      m.addLayer({



        id:LAYER_ID,



        type:"circle",



        source:SOURCE_ID,



        paint:{



          "circle-radius":selectedRadiusExpression(),



          "circle-color":selectedColorExpression(),



          "circle-opacity":selectedOpacityExpression(),



          "circle-stroke-width":selectedStrokeExpression(),



          "circle-stroke-color":selectedStrokeColorExpression()



        }



      });



      layerCreated=true;



    }







    if(!m.getLayer(LABEL_LAYER_ID)){



      m.addLayer({



        id:LABEL_LAYER_ID,



        type:"symbol",



        source:SOURCE_ID,



        layout:{



          "text-field":[

          "case",

          ["==",["get","key"],selectedKey],"★",

          ["==",["get","tier"],"featured"],"★",

          ""

        ],



          "text-size":labelSizeExpression(),



          "text-allow-overlap":true,



          "text-ignore-placement":true,



          "text-anchor":"center"



        },



        paint:{



          "text-color":labelColorExpression(),



          "text-halo-color":"rgba(255,255,255,0)",



          "text-halo-width":0



        }



      });



    }







    /* Transparent circle expands the touch target on narrow iPhones.
       Same source/key as visible marker, and no extra markers are created. */
    if(!m.getLayer(HIT_LAYER_ID)){
      m.addLayer({
        id:HIT_LAYER_ID,type:"circle",source:SOURCE_ID,
        paint:{
          "circle-radius":23,
          "circle-color":"#ffffff",
          "circle-opacity":0.001,
          "circle-stroke-width":0
        }
      });
    }

    if(sourceCreated){



      lastWrittenSource=null;



      lastWrittenSignature="";



    }







    bindLayerListeners(m);







    return {



      ready:true,



      map:m,



      sourceCreated:sourceCreated,



      layerCreated:layerCreated



    };



  }catch(error){



    return {



      ready:false,



      map:m,



      sourceCreated:sourceCreated,



      layerCreated:layerCreated,



      error:error



    };



  }



}







function cancelRecovery(){



  if(recoveryTimer){



    window.clearTimeout(recoveryTimer);



    recoveryTimer=null;



  }



}







function scheduleRecovery(){



  if(



    recoveryTimer||



    recoveryAttempts>=MAX_RECOVERY_ATTEMPTS||



    !committedItems.length



  ){



    return;



  }







  recoveryTimer=window.setTimeout(function(){



    recoveryTimer=null;



    recoveryAttempts+=1;







    if(restoreCommitted("scheduled-recovery")){



      recoveryAttempts=0;



      return;



    }







    scheduleRecovery();



  },RECOVERY_DELAY_MS);



}







function updateSelectedPaint(m){



  if(!m||!m.getLayer(LAYER_ID)){



    return false;



  }







  try{



    m.setPaintProperty(



      LAYER_ID,



      "circle-radius",



      selectedRadiusExpression()



    );







    m.setPaintProperty(



      LAYER_ID,



      "circle-stroke-width",



      selectedStrokeExpression()



    );







    m.setPaintProperty(



      LAYER_ID,



      "circle-color",



      selectedColorExpression()



    );







    m.setPaintProperty(



      LAYER_ID,



      "circle-opacity",



      selectedOpacityExpression()



    );







    m.setPaintProperty(



      LAYER_ID,



      "circle-stroke-color",



      selectedStrokeColorExpression()



    );







    if(m.getLayer(LABEL_LAYER_ID)){



      m.setLayoutProperty(LABEL_LAYER_ID,"text-size",labelSizeExpression());



      m.setPaintProperty(LABEL_LAYER_ID,"text-color",labelColorExpression());



    }







    if(m.getLayer(GLOW_LAYER_ID)){



      m.setPaintProperty(



        GLOW_LAYER_ID,



        "circle-radius",



        selectedGlowRadiusExpression(23)



      );







      m.setPaintProperty(



        GLOW_LAYER_ID,



        "circle-opacity",



        selectedGlowOpacityExpression(0.30)



      );



    }







    return true;



  }catch(error){



    return false;



  }



}







function writeSource(items,options){



  var supplied=options||{};







  preserveSelectedIdentity(items);







  var ensured=ensureLayer();



  var m=ensured.map;



  var source;



  var signature=resultSignature(items);



  var force=supplied.force===true;







  if(!ensured.ready||!m){



    return false;



  }







  try{



    source=m.getSource(SOURCE_ID);







    if(!source){



      return false;



    }







    /*



      Source Instance Authority:



      skip only when this exact Mapbox source instance already contains



      this exact immutable result signature.



    */



    if(



      !force&&



      source===lastWrittenSource&&



      signature===lastWrittenSignature



    ){



      updateSelectedPaint(m);







      if(selectedKey){



        startPulse();



      }







      return true;



    }







    source.setData(featureCollection(items));







    lastWrittenSource=source;



    lastWrittenSignature=signature;







    updateSelectedPaint(m);







    if(selectedKey){



      startPulse();



    }







    return true;



  }catch(error){



    return false;



  }



}







function emitCommitted(reason){



  try{



    events.emit("pins:committed",{



      count:committedItems.length,



      signature:committedSignature,



      committedAt:committedAt,



      reason:String(reason||"scan-complete")



    });



  }catch(error){}



}







function commit(items,options){



  var supplied=options||{};



  var normalized=validItems(items);



  var signature=resultSignature(normalized);



  var force=supplied.force===true;



  var sameCommit=(



    signature===committedSignature&&



    committedItems.length===normalized.length



  );







  /*



    Result Authority:



    Scan, UI, Photo IQ, and shelf callbacks may present the same result set,



    but only a missing/recreated Mapbox source is allowed to trigger another



    physical source write.



  */



  preserveSelectedIdentity(normalized);







  if(!sameCommit){



    committedItems=normalized.slice();



    committedSignature=signature;



    committedAt=now();



  }







  cancelRecovery();







  if(writeSource(committedItems,{



    force:force



  })){



    recoveryAttempts=0;







    refreshResultsToggle();







    if(!sameCommit||force||supplied.emit===true){



      emitCommitted(supplied.reason);



    }







    return true;



  }







  scheduleRecovery();



  return false;



}







/* Compatibility alias used by Scan V600.23+. */



function render(items){



  return commit(items,{



    force:false,



    reason:"render-alias"



  });



}







function restoreCommitted(reason){



  var items=committedItems.length



    ? committedItems



    : validItems(state.get("results.items",[]));







  if(!items.length){



    return false;



  }







  if(!committedItems.length){



    committedItems=items.slice();



    committedSignature=resultSignature(items);



    committedAt=now();



  }







  return commit(committedItems,{



    force:true,



    emit:false,



    reason:reason||"map-recovery"



  });



}







function clear(){



  var m=map();



  var source;







  cancelRecovery();



  stopPulse();







  committedItems=[];



  committedSignature="";



  committedAt=0;



  selectedKey="";



  selectedItem=null;



  recoveryAttempts=0;



  lastWrittenSource=null;



  lastWrittenSignature="";



  lastSelectedItem=null;







  refreshResultsToggle();







  if(!m){return false;}







  try{



    source=m.getSource(SOURCE_ID);







    if(source){



      source.setData(featureCollection([]));



      lastWrittenSource=source;



      lastWrittenSignature="";



    }







    updateSelectedPaint(m);



    return true;



  }catch(error){



    return false;



  }



}











function highlight(item){



  var m=map();







  if(!item){return false;}







  if(!setSelectedItem(item)){



    return false;



  }







  updateSelectedPaint(m);



  startPulse();







  try{



    safeEmit("pin:highlighted",{



      item:selectedItem||item,



      place:selectedItem||item,



      result:selectedItem||item,



      key:selectedKey,



      source:"shared-selection"



    });



  }catch(error){}







  nextPaint(function(){



    reassertSelection("highlight");



  });







  window.setTimeout(function(){



    reassertSelection("highlight-settled");



  },120);







  return true;



}







function clearSelection(){



  var m=map();







  selectedKey="";



  selectedItem=null;



  lastSelectedItem=null;



  stopPulse();



  updateSelectedPaint(m);







  return true;



}







function select(item,source){



  var m=map();







  if(!item){return false;}







  if(!setSelectedItem(item)){



    return false;



  }







  updateSelectedPaint(m);



  startPulse();







  try{



    state.selectPlace(



      selectedItem||item,



      source||"pin"



    );



  }catch(error){



    return false;



  }







  nextPaint(function(){



    reassertSelection("state-select");



  });







  window.setTimeout(function(){



    reassertSelection("state-select-settled");



  },120);







  return true;



}











function reassertSelection(reason){



  var m=map();



  var item=itemForSelectedKey();







  if(!selectedKey){



    return false;



  }







  if(item){



    selectedItem=item;



    lastSelectedItem=item;



  }







  if(!ensureLayer().ready){



    scheduleRecovery();



    return false;



  }







  updateSelectedPaint(m);



  startPulse();







  safeEmit("pin:selection-reasserted",{



    item:selectedItem,



    key:selectedKey,



    reason:String(reason||"reassert")



  });







  return true;



}







/*



  Scan completion is the only normal pin-commit event.



  Photo resolution, thumbnail hydration, Place IQ rendering, and UI mode



  changes never call into Pins.



*/



events.on("scan:completed",function(event){



  var payload=event&&event.payload?event.payload:{};



  var results=normalizeResultItems(



    payload.results||



    payload.items||



    state.get("results.items",[])



  );







  commit(results,{



    force:false,



    reason:"scan-completed"



  });







  if(selectedKey){



    window.setTimeout(function(){



      reassertSelection("scan-completed");



    },0);







    window.setTimeout(function(){



      reassertSelection("scan-completed-settled");



    },180);



  }



});







function handleMapRecovery(reason){



  /*



    Mapbox removes custom sources/layers during style replacement.



    Explicitly detach old delegated handlers before rebuilding so repeated



    style-ready events cannot multiply pin click behavior.



  */



  unbindLayerListeners();



  boundMap=null;



  lastWrittenSource=null;



  lastWrittenSignature="";



  recoveryAttempts=0;



  restoreCommitted(reason);







  if(selectedKey){



    reassertSelection(reason||"map-recovery");







    window.setTimeout(function(){



      reassertSelection(



        String(reason||"map-recovery")+"-settled"



      );



    },120);



  }



}







events.on("map:ready",function(){



  handleMapRecovery("map-ready");



});







events.on("map:style-ready",function(){



  handleMapRecovery("map-style-ready");



});







window.addEventListener("pageshow",function(event){



  recoveryAttempts=0;







  /*



    A persisted page resume may retain the existing source. The source



    instance guard prevents unnecessary writes unless recovery is forced.



  */



  restoreCommitted(



    event&&event.persisted



      ? "pageshow-bfcache"



      : "pageshow"



  );







  if(selectedKey){



    window.setTimeout(function(){



      reassertSelection("pageshow");



    },100);



  }



});







ensureResultsToggle();







window.DriveIQAdventurePins={



  commit:commit,



  render:render,



  clear:clear,



  select:select,



  highlight:highlight,



  clearSelection:clearSelection,



  reassertSelection:reassertSelection,



  resolveCommittedItem:resolveCommittedItem,



  keyFor:keyFor,



  showResults:showResultsAuthority,



  openPlace:openPlaceAuthority,







  /* Recovery only. Do not use this during normal photo/UI updates. */



  repaint:function(){



    recoveryAttempts=0;



    lastWrittenSource=null;



    lastWrittenSignature="";



    return restoreCommitted("explicit-repaint");



  },







  status:function(){



    var m=map();



    var source=null;







    try{



      source=m&&m.getSource



        ? m.getSource(SOURCE_ID)



        : null;



    }catch(error){}







    return {



      build:"V600_45_GOLD_PIN_POST_REPAINT_AUTHORITY",



      committedCount:committedItems.length,



      committedSignature:committedSignature,



      committedAt:committedAt,



      selectedKey:selectedKey,



      selectedItemKey:selectedItem



        ? keyFor(selectedItem)



        : "",



      pulseActive:!!pulseTimer,



      labelLayerReady:!!(m&&m.getLayer&&m.getLayer(LABEL_LAYER_ID)),



      glowLayerReady:!!(



        m&&



        m.getLayer&&



        m.getLayer(GLOW_LAYER_ID)



      ),



      recoveryAttempts:recoveryAttempts,



      listenersBound:listenersBound,



      resultsToggleReady:!!(



        window.document&&



        window.document.getElementById(RESULTS_TOGGLE_ID)



      ),



      lastSelectedKey:lastSelectedItem



        ? keyFor(lastSelectedItem)



        : "",



      layerReady:!!(



        m&&



        m.getLayer&&



        m.getLayer(LAYER_ID)



      ),



      sourceReady:!!source,



      sourceCommitted:!!(



        source&&



        source===lastWrittenSource&&



        committedSignature===lastWrittenSignature



      )



    };



  }



};







console.log(



  "[Drive IQ Adventure V600]",



  "Category pin hierarchy V600.46 loaded"



);







})(window);








